import React from 'react';
import { CardArt, Heading } from '@americanexpress/dls-react';
import parse from "html-react-parser";
import { EligibilityCriteria } from '../../components';
function Banner({ cardImage, bannerTitle, bannerUrl, cardDisplayName, eligibilityCriteria, displayCityNames }) {
    return (
        <div className="pad-t text-align-center">
            <div>
                <div className="flex flex-item-grow flex-justify-center pad-1-lr ">
                    <CardArt size="lg" tilt={true}> <img
                        src={cardImage}
                        alt="card-art"
                    /></CardArt>

                </div>
                <Heading level={3} headingStyle="heading3">{parse(bannerTitle)}</Heading>
            </div>
            <div className="flex flex-align-center pad-3-t pad-responsive">
                <EligibilityCriteria eligibilityCriteria={eligibilityCriteria} cityList={displayCityNames} />
            </div>
        </div>
    );
}
export default Banner;